(function () {
    'use strict';

    angular
        .module('directives.oddPlaceholder', [])
        .directive('oddPlaceholder', directive);

    function directive() {
        return {
            link: function (scope, elem, attrs) {
                var placeholder = attrs.oddPlaceholder;
                if (placeholder) {
                    elem.attr('placeholder', placeholder);
                }
            }
        }
    }
})();